import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'cut-body',
    template: require('./body.html'),
    styles: [require('./fonts.scss')],
    encapsulation: ViewEncapsulation.None
})
export class BodyComponent {

}
